/** @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ModalMultiSelectField, SelectItem } from '../../../shared/ModalMultiSelectField';
import { useAppDispatch } from '../../../core/store';
import {
  fetchReadOnlyDistributionListMembers,
  selectIsFetching,
  selectReadOnlyDistributionListMembers,
} from '../store/assessmentBulkUpdateSlice';
import { AssessmentBulkUpdateFilters } from '../model/assessmentBulkUpdateQueryParams';
import { Contact } from '../../users/model/user.model';

interface ReadOnlyDistributionListMemberMultiSelectFieldProps {
  filters: AssessmentBulkUpdateFilters;
  defaultValue?: string[];
  editable?: boolean;
  onUpdate?: (value: string[]) => void;
}

export function ReadOnlyDistributionListMemberMultiSelectField({
  filters,
  defaultValue = [],
  editable = false,
  onUpdate,
}: ReadOnlyDistributionListMemberMultiSelectFieldProps) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (editable) {
      dispatch(fetchReadOnlyDistributionListMembers(filters));
    }
  }, [dispatch, editable, filters]);
  const { t } = useTranslation();

  const readOnlyDistributionListMemberList = useSelector(selectReadOnlyDistributionListMembers);
  const isFetching = useSelector(selectIsFetching);

  const toSelectItem = (item: Contact | undefined): SelectItem => {
    if (item == null) {
      return { code: '', description: '' };
    }

    return {
      code: item.email,
      description: item.email,
      subdescription: item.name,
    };
  };

  const toString = (item: SelectItem): string => {
    return item.code;
  };

  return (
    <ModalMultiSelectField
      icon='mail'
      defaultValue={
        defaultValue != null
          ? defaultValue.map(v => toSelectItem(readOnlyDistributionListMemberList.find((s: Contact) => s.email === v)))
          : []
      }
      loading={isFetching}
      list={readOnlyDistributionListMemberList.map((b: any): SelectItem => toSelectItem(b) as SelectItem)}
      title={t('assessment.bulkUpdate.filters.readOnlyDistributionList') || ''}
      editable={editable}
      onUpdateValue={(selectedStore: SelectItem[]) => {
        if (onUpdate) {
          onUpdate(selectedStore.map(i => toString(i)));
        }
      }}
    />
  );
}
